import React, { useState, useRef } from 'react';
import axios from 'axios';
import { rootUrl } from '../../../helpers';
import { FaSpinner } from 'react-icons/fa';
import { useOutletContext } from 'react-router-dom';
import { useAuth } from '../../../context/auth-context';
import DataTable from "react-data-table-component";
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

const ActualBills = () => {
  const { allData } = useOutletContext();
  const [period, setPeriod] = useState('jan-jun');
  const [year, setYear] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(false);
  const [bills, setBills] = useState(null);
  const [error, setError] = useState(null);
  const {user} = useAuth();
  const componentRef = useRef(null);
  const [exporting, setExporting] = useState(false);
  const [locationFilter, setLocationFilter] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setBills(null);
    let startDate, endDate;
    if (period === 'jan-jun') {
      startDate = `${year}-01-01`;
      endDate = `${year}-06-30`;
    } else {
      startDate = `${year}-07-01`;
      endDate = `${year}-12-31`;
    }
    try {
      const cid = user?.cid
      const response = await axios.get(rootUrl(`/actualBills/${cid}~${startDate}~${endDate}`));
      setBills(response.data.data || response.data);
    } catch (err) {
      setError('Failed to fetch bills.');
    } finally {
      setLoading(false);
    }
  };

  // Get a list of years for the filter (e.g., last 10 years)
  const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);

  // Get unique locations from bills
  const locations = bills ? Array.from(new Set(bills.map(b => b.location).filter(Boolean))) : [];

  // Filter bills by location if filter is set
  const filteredBills = bills && locationFilter
    ? bills.filter(b => b.location === locationFilter)
    : bills;

  const columns = [
    {
      name: 'Plot',
      selector: row => row.property_no || row.Property_no || '-',
      sortable: true,
    },
    {
      name: 'Location',
      selector: row => row.location || '-',
      sortable: true,
    },
    {
      name: 'Customer',
      selector: row => allData?.suppliers.find(a=>a.id == row.customer)?.name,
      sortable: true,
    },
    {
      name: 'Bill Amount',
      selector: row => row.amount,
      sortable: true,
    },
    {
      name: 'Description',
      selector: row => row.description,
      sortable: true,
    },
    {
      name: 'Invoice No',
      selector: row => row.invoice_no,
      sortable: true,
    },
    {
      name: 'Opening Balance',
      selector: row => row.opening_balance,
      sortable: true,
    },
  ];

  // Helper to render a single invoice as HTML for PDF
  const renderInvoiceHTML = (bill) => {
    const logoUrl = rootUrl(`/${allData?.council?.[0]?.path}`);
    const today = new Date();
    const billDate = bill.date ? new Date(bill.date) : null;

   


    return `
      <div style="width: 700px; padding: 24px; font-family: Arial, sans-serif; border: 1px solid #e5e7eb; margin-bottom: 32px;">
        <div style="text-align: center;">
          <img src='${logoUrl}' alt="Council Logo" style="width: 120px; margin-bottom: 8px;" />
          <h2 style="font-size: 24px; font-weight: bold; margin: 0;">${allData?.council?.[0]?.name || ''}</h2>
          <div style="font-size: 16px; margin: 4px 0 8px 0; color: #334155; font-weight: 500;">
            Period: ${period === 'jan-jun' ? 'Jan - Jun' : 'Jul - Dec'} ${year}
          </div>
          <h3 style="font-size: 18px; font-weight: 600; margin: 8px 0 16px 0; color: #1e293b;">PROPERTY RATES BILL</h3>
        </div>
        <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
          <div style="width: 48%;">
            <p><strong>Owner:</strong> ${allData?.suppliers.find(a=>a.id == bill.customer)?.name || '-'}</p>
            <p><strong>Plot:</strong> ${bill.property_no || bill.Property_no || '-'}</p>
            <p><strong>Street:</strong> ${bill.street || '-'}</p>
            <p><strong>Town/Zone:</strong> ${bill.location || '-'}</p>
            <p><strong>Description:</strong> ${bill.description || '-'}</p>
          </div>
          <div style="width: 48%;">
            <p><strong>Invoice No:</strong> ${bill.invoice_no || '-'}</p>
            <p><strong>Improve Value:</strong> ${bill.improvements || '-'}</p>
            <p><strong>Land Value:</strong> ${bill.land_value || '-'}</p>
            <p><strong>Rate Used:</strong> ${bill.annual_payable ? (parseFloat(bill.annual_payable) / 2) : '-'}</p>
            <p><strong>Hectares:</strong> ${bill.land_ext || '-'}</p>
          </div>
        </div>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 16px;">
          <thead>
            <tr style="background: #1e293b; color: #fff;">
              <th style="border: 1px solid #e5e7eb; padding: 8px;">Opening Balance</th>
              <th style="border: 1px solid #e5e7eb; padding: 8px;">Bill Amount</th>
              <th style="border: 1px solid #e5e7eb; padding: 8px;">Actual Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid #e5e7eb; padding: 8px; text-align: right;">${bill.opening_balance || 0}</td>
              <td style="border: 1px solid #e5e7eb; padding: 8px; text-align: right;">${bill.amount || 0}</td>
              <td style="border: 1px solid #e5e7eb; padding: 8px; text-align: right; font-weight: bold;">${(parseFloat(bill.opening_balance || 0) + parseFloat(bill.amount || 0))}</td>
            </tr>
          </tbody>
        </table>
      
        <div style="display: flex; justify-content: space-between; margin-top: 32px;">
          <div>
            <p><strong>Issued By:</strong> __________________</p>
            <p><strong>Signature:</strong> __________________</p>
          </div>
          <div>
            <p><strong>Received By:</strong> _________________</p>
            <p><strong>Signature:</strong> ___________________</p>
          </div>
        </div>
      </div>
    `;
  };

  const handleExportPDF = async () => {
    if (!filteredBills || filteredBills.length === 0) return;
    setExporting(true);
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const pdfWidth = pageWidth - 20;
    const invoiceHeight = (pageHeight - 40) / 3; // 3 invoices per page, 10mm margin top/bottom, 10mm between
    let yOffset = 10;
    let invoiceOnPage = 0;
    for (let i = 0; i < filteredBills.length; i++) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = renderInvoiceHTML(filteredBills[i]);
      document.body.appendChild(tempDiv);
      await new Promise((resolve) => setTimeout(resolve, 200));
      await html2canvas(tempDiv, { scale: 2 }).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        // Calculate height to fit 3 per page
        if (invoiceOnPage === 3) {
          pdf.addPage();
          yOffset = 10;
          invoiceOnPage = 0;
        }
        pdf.addImage(imgData, 'PNG', 10, yOffset, pdfWidth, invoiceHeight);
        yOffset += invoiceHeight + 10; // 10mm gap between invoices
        invoiceOnPage++;
      });
      document.body.removeChild(tempDiv);
    }
    pdf.save(`ActualBills_${year}_${period}.pdf`);
    setExporting(false);
  };

  return (
    <div className="w-full bg-white min-h-[400px] rounded-md mt-10 p-5">
      <h2 className="font-bold text-2xl mb-4">Actual Bills</h2>
      <form className="flex flex-wrap gap-4 items-end mb-6" onSubmit={handleSubmit}>
        <div>
          <label className="block mb-1 font-semibold">Period</label>
          <select
            className="border rounded px-3 py-2"
            value={period}
            onChange={e => setPeriod(e.target.value)}
          >
            <option value="jan-jun">Jan - Jun</option>
            <option value="jul-dec">Jul - Dec</option>
          </select>
        </div>
        <div>
          <label className="block mb-1 font-semibold">Year</label>
          <select
            className="border rounded px-3 py-2"
            value={year}
            onChange={e => setYear(e.target.value)}
          >
            {years.map(y => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
        </div>
        <button
          type="submit"
          className="bg-blue-950 text-white px-4 py-2 rounded hover:bg-blue-900"
          disabled={loading}
        >
          {loading ? <FaSpinner className="animate-spin inline mr-2" /> : null}
          Submit
        </button>
        <button
          type="button"
          className="bg-blue-700 text-white px-4 py-2 rounded hover:bg-blue-800 ml-2"
          onClick={handleExportPDF}
          disabled={exporting}
        >
          {exporting ? <FaSpinner className="animate-spin inline mr-2" /> : null}
          Export Bills
        </button>
      </form>
      {/* Location Filter */}
      {bills && locations.length > 0 && (
        <div className="mb-4">
          <label className="font-semibold mr-2">Filter by Location:</label>
          <select
            className="border rounded px-3 py-2"
            value={locationFilter}
            onChange={e => setLocationFilter(e.target.value)}
          >
            <option value="">All Locations</option>
            {locations.map(loc => (
              <option key={loc} value={loc}>{loc}</option>
            ))}
          </select>
        </div>
      )}
      {loading && (
        <div className="flex justify-center items-center py-10">
          <FaSpinner className="animate-spin" size={40} />
        </div>
      )}
      {error && (
        <div className="text-red-600 font-semibold mb-4">{error}</div>
      )}
      {filteredBills && Array.isArray(filteredBills) && filteredBills.length > 0 && (
        <div ref={componentRef}>
          <DataTable
            columns={columns}
            data={filteredBills}
            pagination
            highlightOnHover
            striped
            responsive
          />
        </div>
      )}
      {filteredBills && Array.isArray(filteredBills) && filteredBills.length === 0 && !loading && (
        <div className="text-gray-600 font-semibold">No bills found for the selected period.</div>
      )}
    </div>
  );
};

export default ActualBills; 